module.exports = __webpack_public_path__ + "static/media/AB_ZW10_10.959b5db5.jpg";